<template>
  <div class="table_card">
    <div class="table_card__head">
      <v-layout row wrap fill-height>
        <v-flex xs12 lg8>
          <p class="table_card__head--title">Dispositivos</p>
          <v-breadcrumbs class="breadcums">
            <v-icon slot="divider">chevron_right</v-icon>
            <v-breadcrumbs-item class="breadcums__option">
              Listado de dispositivos
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-flex>
        <v-flex xs12 lg4 class="filter_options">
          <v-flex class="right mr-20">
            <button
              class="faccess_button"
              @click="$router.push({ name: 'new_device' })"
            >
              Crear nuevo dispositivo
            </button>
          </v-flex>
          <div class="buttom_reload" @click="getDevices()">
            <img src="@/assets/img/icons/refresh-icon.svg" />
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div>
      <v-data-table
        :headers="headers"
        :items="devices"
        hide-actions
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">
            <a style="cursor: pointer" @click="editItem(props.item.id)">
              {{ props.item.name }}
            </a>
          </td>
          <td class="text-xs-center">{{ props.item.location }}</td>
          <td class="text-xs-center">
            {{ !props.item.uuid ? props.item.name.split('-')[0].trim() : props.item.uuid }}
          </td>
          <td class="text-xs-center">
            <a @click.prevent="showConfirmModal(props.item)">
              Desvincular
            </a>
          </td>
        </template>
      </v-data-table>

      <div class="table_card__footer justify-content-start">
        <nav class="pagination" role="navegation" aria-label="pagination">
          <v-pagination
            :value ="page"
            :length="pages"
            @input ="changePage"
          />
        </nav>
      </div>


    </div>

    <section
      v-if="show_confirm_modal"
      class="access_devices__modal">
      <section class="access_devices__modal--container" style="width: 40%;">
        <p class="access_devices__modal--text" style="text-align: justify;">
          <b>AVISO:</b> Al desvincular el dispositivo se <b>eliminará</b> su UUID y pasará a estar inactivo.
        </p>
        <br>
        <p class="access_devices__modal--text">
          ¿Está seguro de desvincular el dispositivo?
        </p>
        <div class="access_devices__modal--buttons" style="margin-top: 1rem;">
          <div
            class="access_devices__modal--button"
            @click="closeConfirmModal">
            Cancelar
          </div>
          <div
            class="access_devices__modal--button active"
            @click="removeDevice">
            Si
          </div>
        </div>
      </section>
    </section>


  </div>
</template>

<script>
export default {
  data() {
    return {
      modal_details: false,
      devices: [],
      headers: [
        { text: "Nombre", sortable: false, value: "name", align: "center"},
        { text: "Locación", sortable: false, value: "location", align: "center"},
        { text: "UUID", sortable: false, value: "uuid", align: "center"},
        { text: "Desvincular", value: "name", sortable: false, align: "center"}
      ],
      device: [],
      show_confirm_modal: false,
      page: 1,
      pages: 1
    };
  },
  mounted() {
    this.getDevices();
  },
  methods: {

    showConfirmModal(data){
      this.device = data
      this.show_confirm_modal = true
    },

    closeConfirmModal(){
      this.device = []
      this.show_confirm_modal = false
    },



    removeDevice() {
      const data = { device_info: this.device };
      try {
        this.$http
          .post(
            "scan_peripheral/remove_peripheral",
            {
              data: this.encrypt(data).toString()
            },
            {
              headers: {
                "X-Device-ID": this.getDeviceId(),
                Authorization: "Bearer " + this.getUserToken()
              }
            }
          )
          .then(
            function(response) {
              this.updateAlertMessage(response.body.ans);
              this.updateIsInAlert(true);
              this.show_confirm_modal = false
              this.getDevices()
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
            },
            function(response) {
              this.updateAlertMessage(response.body.ans);
              this.updateIsInAlert(true);
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
            }
          );
      } catch (e) {
        this.show_confirm_modal = false
        if (response.body.meta != undefined && response.body.meta != null) {
          if (
            response.body.meta.authentication_token != undefined &&
            response.body.meta.authentication_token != null
          ) {
            this.checkToken(response.body.meta.authentication_token);
          }
        }
        alert(e.message);
      }
    },


    editItem(id) {
      this.$router.push({ name: "edit_device", params: { id: id } });
    },

    getDevices() {
      let params = { page: this.page }
      try {
        this.$http
          .get("scan_peripheral/get_devices", {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            },
           params
          })
          .then(
            function(response) {
              this.devices = response.body.devices;
              console.log('devices---------------->', this.devices)
              this.pages = response.body.pages
            },
            function(response) {
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
            }
          );
      } catch (e) {
        alert(e.message);
      }
    },

    changePage (page){
      this.page = page
      this.getDevices();
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/devices/Index.vue